(function ($) {
    function ShopifyFilter(element, params) {

        if (typeof element == 'string') {
            // The first parameter must be a DOM selector.
            this.initWithSelector(element, params);
        } else {
            // The first parameter must be a DOM element.
            this.initWithElement(element, params);
        }
    }

    ShopifyFilter.prototype = {
        DEBUG: false,
        element: null,
        cachePath: null,
        expiryOffset: 120000, // 2 minutes
        enableColourMappings: false,
        hideUnavailableProducts: false,
        colourMappings: null,
        colourOptionName: 'Colour',
        products: [],
        productsFiltered: [],
        productsDisplayed: [],
        productTemplate: null,
        productsContainer: null,
        productsContainerSelector: null,
        filter: null,
        tagWhitelist: null,
        tagBlacklist: null,
        optionBlacklist: null,
        totalProducts: null,
        totalPages: null,
        totalPerPage: 24,
        maxPerPage: 250,
        pages: null,
        params: {
            page: 0,
            q: '',
            type: '',
            sort_by: ''
        },
        pagination: {
            selector: null,
            element: null,
            nextText: null,
            prevText: null
        },
        currencyPrefix: '$',

        // Methods
        onStart: $.noop,
        onFinish: $.noop,
        onPageChange: $.noop,
        init: function (params) {
            var _self = this;

            if (_self.element == null || _self.element.length == 0) {
                throw new Error('No filter element set.');
            }

            if (typeof params.totalProducts != 'number' ) {
                throw new Error('totalProducts parameter must be set and a valid positive integer.');
            }

            if (typeof params.productTemplate != 'string' ) {
                throw new Error('productTemplate must be a valid DOM selector.');
            }

            if (typeof params.productsContainer != 'string' ) {
                throw new Error('productsContainer must be a valid DOM selector.');
            }

            if (typeof params.paginationContainer != 'string' ) {
                throw new Error('paginationContainer must be a valid DOM selector.');
            }

            _self.DEBUG = params.DEBUG || false;
            _self.startTimer();
            _self.onStart();

            _self.totalProducts = params.totalProducts;
            _self.totalPages = Math.ceil(_self.totalProducts / _self.maxPerPage);
            _self.productTemplate = Handlebars.compile($(params.productTemplate).html());
            _self.productsContainerSelector = params.productsContainer;
            _self.enableColourMappings = params.enableColourMappings || false;
            _self.hideUnavailableProducts = params.hideUnavailableProducts || false;
            _self.tagWhitelist = params.tagWhitelist || null;
            _self.tagBlacklist = params.tagBlacklist || null;
            _self.optionBlacklist = params.optionBlacklist || null;
            _self.pagination.selector = params.paginationContainer;
            _self.pagination.nextText = params.paginationNextText || 'Next';
            _self.pagination.prevText = params.paginationPrevText || 'Previous';
            _self.onStart = params.onStart || $.noop;
            _self.onFinish = params.onFinish || $.noop;
            _self.onPageChange = params.onPageChange || $.noop;
            _self.generateCachePath();
            _self.initQuery();
            if (!_self.initCache()) {
                _self.getProducts().done(function () {
                    _self.setCache();
                    _self.finalize();
                });
            } else {
                _self.finalize();
            }
        },
        finalize: function () {
            this.buildFilter();
            if (this.isFiltering()) {
                this.log('Apply filter');
                this.applyFilter();
            } else {
                this.refreshPagination();
            }

            this.productsDisplayed = this.productsFiltered.slice(this.totalPerPage * (this.params.page - 1), this.totalPerPage * this.params.page);

            this.onFinish(this);
            this.endTimer();
        },
        initWithSelector: function (elementSelector, params) {
            this.element = $(elementSelector);
            this.init(params);
        },
        initWithElement: function (element, params) {
            this.element = element;
            this.init(params);
        },
        initCache: function () {
            if (this.isSearching()) {
                return true;
            }

            var cacheJSON = window.sessionStorage[this.cachePath];
            if (cacheJSON) {
                var productStore =  this.parseJSON(cacheJSON);
                if (Date.now() < productStore.expiry) {
                    this.log('Using cached products.');

                    var _processed = {};
                    this.products = this.productsFiltered = productStore.products.filter(function (product) {
                        if (_processed['' + product.id]) {
                            return false;
                        }
                        _processed['' + product.id] = true;
                        return true;
                    });

                    return true;
                } else {
                    this.log('Product cache invalidated');
                    delete window.sessionStorage[this.cachePath];
                }
            }

            return false;
        },
        setCache: function () {
            var _self = this;
            this.products = this.products.map(function (p) {
                return _self.objectOmit(['body_html', 'created_at', 'updated_at'], p);
            });

            var productStore = _self.serializeJSON({
                expiry: Date.now() + _self.expiryOffset,
                products: _self.products
            });

            try {
                window.sessionStorage[this.cachePath] = productStore;
            } catch (e) {
                console.error('Failed to cache products.');
            }
        },
        initQuery: function () {
            var _params = this.getQueryParams();
            this.filter = this.objectExtend({ option: {}, colour: {}, tag: {} }, _params.filter);
            if (_params.page) {
                this.params.page = _params.page;
            } else {
                this.params.page = 1;
            }

            if (_params.sort_by && _params.sort_by != 'best-selling') {
                this.params.sort_by = _params.sort_by;
            }
        },
        getProducts: function () {
            var _self = this;
            var dfd = $.Deferred();

            var _pages = [];
            var searchPath = _self.getSearchPath();
            for (var page = 1; page < (_self.totalPages + 1); page++) {
                // Must execute inside a closure to ensure the '_page' variable is accurate upon resolved promise.
                (function (_page) {
                    $.get(searchPath, { limit: _self.maxPerPage, page: _page }).done(function (response) {
                        _pages.push({
                            page: _page,
                            products: response.products
                        });

                        // This must be the last response.
                        if (_pages.length == _self.totalPages) {
                            _pages.sort(function (a, b) {
                                return a.page > b.page;
                            });

                            var _products = [];
                            for (var i = 0; i < _self.totalPages; i++) {
                                _products = _products.concat(_pages[i].products);
                            }

                            var _processed = {};
                            _self.products = _self.productsFiltered = _products.filter(function (product) {
                                if (_processed['' + product.id]) {
                                    return false;
                                }
                                _processed['' + product.id] = true;
                                return true;
                            });
                            dfd.resolve();
                        }
                    });
                })(page);
            }

            return dfd.promise();
        },
        buildFilter: function () {
            var _self = this;
            var _filter = {
                price: {
                    price_max: 0,
                    price_min: 0,
                    name: 'Price',
                    type: 'price'
                }
            };
            _self.colourMappings = {};

            for (var ip = 0, lp = _self.products.length; ip < lp; ip++) {
                var product = _self.products[ip];

                for (var iv = 0, lv = product.variants.length; iv < lv; iv++) {
                    var variant = product.variants[iv];
                    var _price = parseFloat(variant.price);
                    if (!isNaN(_price)) {
                        if (_price > _filter.price.price_max) {
                            _filter.price.price_max = _price;
                        }
                    }
                }

                for (var io = 0, lo = product.options.length; io < lo; io++) {
                    var option = product.options[io];

                    if (_self.optionBlacklist != null && ~_self.optionBlacklist.indexOf(option.name)) {
                        continue;
                    }

                    var optionType = _self.getFilterType(option);
                    if (_self.enableColourMappings && optionType == 'colour') {
                        continue;
                    }

                    if (typeof _filter[option.name] == 'undefined') {
                        _filter[option.name] = {
                            name: option.name,
                            values: option.values,
                            type: _self.getFilterType(option)
                        };
                    } else {
                        _filter[option.name].values = _self.arrayUnion(_filter[option.name].values, option.values);
                    }
                }

                var _tags = product.tags.filter(function(a) {
                    return ~a.indexOf(':');
                });

                if (_tags.length > 0) {
                    for (var it = 0, lt = _tags.length; it < lt; it++) {
                        var tag = _tags[it];
                        var _parts = tag.split(':').map(function (n) {
                            return n.trim();
                        });

                        if (_parts.length == 2) {
                            if (_self.tagWhitelist != null && !~_self.tagWhitelist.indexOf(_parts[0])) {
                                continue;
                            }

                            if (_self.tagBlacklist != null && ~_self.tagBlacklist.indexOf(_parts[0])) {
                                continue;
                            }

                            if (typeof _filter[_parts[0]] == 'undefined') {
                                _filter[_parts[0]] = {
                                    name: (_parts[0].substr(0, 1).toUpperCase() + _parts[0].substr(1).toLowerCase()).split('-').join(' '),
                                    values: [_parts[1]],
                                    type: 'tag'
                                }
                            } else {
                                _filter[_parts[0]].values = _self.arrayUnion(_filter[_parts[0]].values, [_parts[1]])
                            }
                        } else if (_self.enableColourMappings && _parts.length == 3 && _parts[0].toLowerCase() == _self.colourOptionName.toLowerCase()) {
                            if (typeof _self.colourMappings[_parts[2]] == 'undefined') {
                                _self.colourMappings[_parts[2]] = [_parts[1]];

                                if (typeof _filter[_self.colourOptionName] == 'undefined') {
                                    _filter[_self.colourOptionName] = {
                                        name: _self.colourOptionName,
                                        values: [_parts[2]],
                                        type: 'colour'
                                    };
                                } else {
                                    _filter[_self.colourOptionName].values = _self.arrayUnion(_filter[_self.colourOptionName].values, [_parts[2]]);
                                }
                            } else {
                                _self.colourMappings[_parts[2]] = _self.arrayUnion(_self.colourMappings[_parts[2]], [_parts[1]]);
                            }
                        }
                    }
                }
            }

            for (var key in _filter) {
                if (_filter.hasOwnProperty(key) && typeof _filter[key].values != 'undefined') {
                    _filter[key].values.sort(_self.naturalCompare);
                }
            }

            _self.buildHTML(_filter);
        },
        buildHTML: function (filter) {
            var _self = this;
            var $html = $('<ul class="advanced-filter" />');
            _self.element.html($html);

            for (var key in filter) {
                if (filter.hasOwnProperty(key)) {
                    _self.buildItemHTML(filter, key, $html);
                }
            }
        },
        buildItemHTML: function (filter, key, $html) {
            var _self = this;
            var item = filter[key];

            var $li = $('<li data-type="' + item.type + '" unselectable="on"><div class="filter-option-title">' + item.name + '</div><div class="filter-option-cont"></div></li>');
            var $header = $li.find('.filter-option-title');
            var $content = $li.find('.filter-option-cont');
            $html.append($li);

            switch (item.type) {
                case 'price':
                    var $slider = $('<div id="price_rangeslider" />');
                    $content.append($slider);
                    $slider.ionRangeSlider({
                        type: 'double',
                        grid: true,
                        min: item.price_min,
                        max: item.price_max,
                        from: _self.filter.price_min || item.price_min,
                        to: _self.filter.price_max || item.price_max,
                        step: 10,
                        prefix: _self.currencyPrefix,
                        prettify_separator: ',',
                        force_edges: true,
                        onFinish: function (data) {
                            _self.filter.price_min = parseFloat(data.from);
                            _self.filter.price_max = parseFloat(data.to);
                            _self.applyFilter();
                        }
                    });
                    break;
                case 'option':
                case 'tag':
                case 'colour':
                    var $valuesList = $('<ul class="filter-option-vals type-' + item.type + '" />');
                    $content.append($valuesList);

                    for (var io = 0, lo = item.values.length; io < lo; io++) {
                        (function (value, filterKey) {
                            var $valueItem = $('<li />', {
                                'data-value':  value
                            });

                            var checked = '';
                            var values = _self.filter[item.type][filterKey];
                            if (typeof values != 'undefined' && ~values.indexOf(value)) {
                                checked = ' checked'
                            }
                            var safeName = item.type + '_' + item.name + '_' + value.replace(/"/g, '').replace(/\s+/g, '_');
                            var $checkbox = $('<input type="checkbox" id="' + safeName + '"' + checked + ' />');
                            var $label = $('<label for="' + safeName + '">' + value + '</label>');

                            $valueItem.append($checkbox);
                            $valueItem.append($label);
                            $valuesList.append($valueItem);

                            $checkbox.change(function () {
                                var _f = _self.filter[item.type][filterKey] || [];

                                if ($(this).is(':checked')) {
                                    _f = _self.arrayUnion(_f, [ value ]);
                                } else {
                                    _f = _self.arrayDifference(_f, [ value ]);
                                }

                                _self.filter[item.type][filterKey] = _f;
                                _self.applyFilter();
                            });
                        })(item.values[io], key)
                    }
                    break;
            }

            $header.click(function() {
                var $this = $(this);

                if ($li.hasClass('active')) {
                    $li.removeClass('active');
                    $this.siblings('.filter-option-cont').stop().slideUp(200);
                } else {
                    $li.addClass('active');
                    $this.siblings('.filter-option-cont').stop().slideDown(200);
                }
            });
        },
        applyFilter: function () {
            var _self = this;

            if (_self.oldTotalPerPage) {
                _self.totalPerPage = _self.oldTotalPerPage;
                _self.oldTotalPerPage = null;
            }

            var _processed = []; // Prevent duplicates.
            _self.productsFiltered = _self.products.filter(function (product) {
                if (_processed['' + product.id]) {
                    return false;
                }
                _processed['' + product.id] = true;

                return _self.matchFilterDown(_self, product);
            });

            if (_self.params.sort_by != '') {
                switch (_self.params.sort_by) {
                    case 'price-ascending':
                        _self.productsFiltered.sort(function (a, b) {
                            var aVariant = a.variants[0];
                            for (var ia = 0, la = a.variants.length; ia < la; ia++) {
                                if (a.variants[ia].available) {
                                    aVariant = a.variants[ia];
                                    break;
                                }
                            }

                            var bVariant = b.variants[0];
                            for (var ib = 0, lb = b.variants.length; ib < lb; ib++) {
                                if (b.variants[ib].available) {
                                    bVariant = b.variants[ib];
                                    break;
                                }
                            }

                            var aPrice = parseFloat(aVariant.price);
                            var bPrice = parseFloat(bVariant.price);

                            if (aPrice <= 0) aPrice = Infinity;
                            if (bPrice <= 0) bPrice = Infinity;

                            return aPrice - bPrice;
                        });
                        break;
                    case 'created-descending':
                        _self.productsFiltered.sort(function (a, b) {
                            return new Date(b.published_at) - new Date(a.published_at);
                        });
                        break;
                }
            }

            _self.showPage(1);
        },
        matchFilterDown: function (_self, product) {
            var _matches = {};

            if (_self.hideUnavailableProducts) {
                var _unavailable = true;
                for (var i = 0, l = product.variants.length; i < l; i++) {
                    var variant = product.variants[i];
                    if (variant.available) {
                        _unavailable = false;
                        break;
                    }
                }

                if (_unavailable) {
                    return false;
                }
            }

            // Filter by options.
            for (var key in _self.filter.option) {
                if (_self.filter.option.hasOwnProperty(key)) {
                    var value = _self.filter.option[key];

                    if (value.length > 0) {
                        for (var iv = 0, lv = product.options.length; iv < lv; iv++) {
                            _matches['opt_' + key] = false;
                            var option = product.options[iv];
                            if (option.name == key) {
                                if (_self.hideUnavailableProducts) {
                                    var _opt_unavailable = true;
                                    for (var i = 0, l = product.variants.length; i < l; i++) {
                                        var variant = product.variants[i];
                                        if (variant['option' + option.position] == value) {
                                            if (variant.available) {
                                                _opt_unavailable = false;
                                                break;
                                            }
                                        }
                                    }

                                    if (_opt_unavailable) {
                                        continue;
                                    }
                                }

                                for (var io = 0, lo = value.length; io < lo; io++) {
                                    var o = value[io];

                                    for (var inn = 0, ln = option.values.length; inn < ln; inn++) {
                                        var n = option.values[inn];
                                        if (o == n) {
                                            _matches['opt_' + key] = true;
                                            break;
                                        }
                                    }

                                    if (_matches['opt_' + key]) {
                                        break;
                                    }
                                }

                                break;
                            }
                        }
                    }
                }
            }


            // Filter by colour.
            if (_self.enableColourMappings) {
                for (var iv = 0, lv = product.options.length; iv < lv; iv++) {
                    var option = product.options[iv];
                    if (_self.getFilterType(option) == 'colour') {
                        for (var key in _self.filter.colour) {
                            if (_self.filter.colour.hasOwnProperty(key)) {
                                var value = _self.filter.colour[key];
                                if (value.length > 0) {

                                    _matches['col_' + option.name] = false;

                                    for (var ic = 0, lc = value.length; ic < lc; ic++) {
                                        var shortColour = value[ic];
                                        var mapping = _self.colourMappings[shortColour];
                                        if (mapping) {
                                            for (var ic = 0, lc = option.values.length; ic < lc; ic++) {
                                                var c = option.values[ic];
                                                if (~mapping.indexOf(c)) {
                                                    _matches['col_' + option.name] = true;
                                                    break;
                                                }
                                            }
                                        }

                                        if (~mapping.indexOf(c)) {
                                            _matches['col_' + option.name] = true;
                                            break;
                                        }
                                    }

                                    if (_matches['col_' + option.name]) {
                                        break;
                                    }
                                }
                            }
                        }

                        if (_matches['col_' + option.name]) {
                            break;
                        }
                    }
                }
            }


            // Filter by tags.
            var _tags = {};
            for (var it = 0, lt = product.tags.length; it < lt; it++) {
                var _tag = product.tags[it];
                var _parts = _tag.split(':').map(function (t) {
                    return t.trim();
                });

                if (_parts.length == 2) {
                    if (!_tags[_parts[0]]) {
                        _tags[_parts[0]] = [];
                    }

                    _tags[_parts[0]].push(_parts[1]);
                }
            }

            for (var key in _self.filter.tag) {
                if (_self.filter.tag.hasOwnProperty(key)) {
                    var value = _self.filter.tag[key];
                    if (value.length > 0) {
                        _matches['tag_' + key] = false;

                        if (_tags[key]) {
                            for (var it = 0, lt = value.length; it < lt; it++) {
                                var tag = value[it];
                                if (~_tags[key].indexOf(tag)) {
                                    _matches['tag_' + key] = true;
                                    break;
                                }
                            }
                        }

                        if (_matches['tag_' + key]) {
                            break;
                        }
                    }
                }
            }

            if (_self.filter.price_min || _self.filter.price_max) {
                _matches['price'] = true;

                for (var iv = 0, lv = product.variants.length; iv < lv; iv++) {
                    var variant = product.variants[iv];
                    var price = parseFloat(variant.price);

                    if (!isNaN(price)) {
                        _matches['price'] &= (price > (_self.filter.price_min || 0));
                        _matches['price'] &= (price < (_self.filter.price_max || Infinity));

                        if (_matches['price']) {
                            break;
                        }
                    }
                }
            }

            for (var key in _matches) {
                if (_matches.hasOwnProperty(key)) {
                    if (!_matches[key]) return false;
                }
            }

            return true;
        },
        showPage: function (page, scrollToTop) {
            var _self = this;

            if (typeof scrollToTop == 'undefined') scrollToTop = false;

            _self.params.page = page;
            var urlParams = {
                page: _self.params.page,
                q: _self.params.q,
                type: _self.params.type
            };
            if (_self.params.sort_by != 'best-selling') {
                urlParams.sort_by = _self.params.sort_by;
            }

            var cleaned = $.extend({}, _self.cleanUrlParams(urlParams), {filter: _self.cleanUrlParams(_self.filter)});
            _self.setUrlParams(cleaned);

            _self.productsDisplayed = _self.productsFiltered.slice(_self.totalPerPage * (_self.params.page - 1), _self.totalPerPage * _self.params.page);
            var html = $(_self.productTemplate({
                products: _self.productsDisplayed
            }));

            if (!_self.productsContainer) _self.productsContainer = $(_self.productsContainerSelector);
            _self.productsContainer.html(html);
            _self.refreshPagination();
            _self.onPageChange(_self, page);

            if (scrollToTop) {
                $(window).scrollTop(0);
            }
        },
        showAllProducts: function () {
            this.oldTotalPerPage = this.totalPerPage;
            this.totalPerPage = this.productsFiltered.length;
            this.showPage(1, true);
        },
        clearFilter: function () {
            this.filter = { option: {}, colour: {}, tag: {} };
            this.buildFilter();
            this.applyFilter();
        },
        isFiltering: function () {
            return (this.filter.max_price || this.filter.min_price || !$.isEmptyObject(this.filter.option) || !$.isEmptyObject(this.filter.tag) || !$.isEmptyObject(this.filter.colour));
        },
        refreshPagination: function () {
            var _self = this;

            if (!_self.pagination.element && (!_self.pageSet && _self.pagination.optional)) {
                _self.log('No need to init pagination.');
                return;
            }

            _self.pages = Math.ceil(_self.productsFiltered.length / _self.totalPerPage);

            try {
                if (!_self.pagination.element) {
                    _self.pagination.element = $(_self.pagination.selector);
                    _self.pagination.element.empty().pagination({
                        items: _self.productsFiltered.length,
                        itemsOnPage: _self.totalPerPage,
                        currentPage: _self.params.page,
                        displayedPages: 3,
                        selectOnClick: false,
                        ellipsePageSet: false,
                        hrefTextPrefix: '?page=',
                        prevText: _self.pagination.prevText,
                        nextText: _self.pagination.nextText,
                        onPageClick: function (pageNumber, event) {
                            event.preventDefault();

                            _self.showPage(pageNumber, true);

                            return false;
                        }
                    });
                } else {
                    _self.pagination.element.pagination('updateItemsOnPage', _self.totalPerPage);
                    _self.pagination.element.pagination('updateItems', _self.productsFiltered.length);
                    _self.pagination.element.pagination('drawPage', _self.params.page);
                }
            } catch (e) {}

            if (_self.pages > 1) {
                _self.pagination.element.show();
            } else {
                _self.pagination.element.hide();
            }
        },
        setUrlParams: function (params) {
            var t = $.param(params), p = '';
            if (t != '') {
                p = '?' + decodeURI(t);
            }

            window.history.pushState({}, '', p);
        },
        cleanUrlParams: function (params) {
            var n = {};
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var value = params[key];
                    if (value) {
                        n[key] = value;
                    }
                }
            }

            return n;
        },
        getFilterType: function (option) {
            if (~['color', 'colour', 'coluor'].indexOf(option.name.trim().toLowerCase())) {
                return 'colour'
            }

            return 'option';
        },
        generateCachePath: function () {
            this.cachePath = window.location.pathname;
        },
        getSearchPath: function () {
            return window.location.pathname + '/products.json';
        },
        getQueryParams: function () {
            var s = window.location.search;
            if (s[0] == '?') {
                s = s.substr(1);
            }

            return this.queryDeparam(s);
        },
        isSearching: function () {
            return window.location.pathname == '/search'
        },
        parseJSON: function (json) {
            return JSON.parse(json);
        },
        serializeJSON: function (obj) {
            return JSON.stringify(obj);
        },
        queryDeparam: function(n, a) {
            var b = {}, f = {'true': !0, 'false': !1, 'null': null};
            $.each(n.replace(/\+/g, " ").split("&"), function(d, e) {
                var g, c = e.split("=");
                g = decodeURIComponent(c[0]);
                var p = b, m = 0, k = g.split("]["), l = k.length - 1;
                /\[/.test(k[0]) && /\]$/.test(k[l]) ? (k[l] = k[l].replace(/\]$/, ""), k = k.shift().split("[").concat(k), l = k.length - 1) : l = 0;
                if (2 === c.length) {
                    if (c = decodeURIComponent(c[1]), a && (c = c && !isNaN(c) ? +c : "undefined" === c ? void 0 : void 0 !== f[c] ? f[c] : c), l) {
                        for (;m <= l;m++) {
                            g = "" === k[m] ? p.length : k[m], p = g = p[g] = m < l ? p[g] || (k[m + 1] && isNaN(k[m + 1]) ? {} : []) : c;
                        }
                    } else {
                        $.isArray(b[g]) ? b[g].push(c) : b[g] = void 0 !== b[g] ? [b[g], c] : c;
                    }
                } else {
                    g && (b[g] = a ? void 0 : "");
                }
            });
            return b;
        },
        arrayUnion: function (x, y) {
            var obj = {};
            for (var xi = x.length - 1; xi >= 0; --xi) {
                obj[x[xi]] = x[xi];
            }
            for (var yi = y.length - 1; yi >= 0; --yi) {
                obj[y[yi]] = y[yi];
            }

            var res = [];
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    res.push(obj[key]);
                }
            }

            return res;
        },
        arrayDifference: function (x, y) {
            return x.filter(function(a) {
                return y.indexOf(a) < 0;
            });
        },
        objectExtend: function (x, y) {
            return $.extend(x, y);
        },
        objectOmit: function (keys, obj) {
            var copy = {};
            for (var key in obj) {
                if (obj.hasOwnProperty(key) && keys.indexOf(key) == -1) {
                    copy[key] = obj[key];
                }
            }

            return copy;
        },
        naturalCompare: function (a, b) {
            var ax = [], bx = [];

            a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { ax.push([$1 || Infinity, $2 || ""]) });
            b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { bx.push([$1 || Infinity, $2 || ""]) });

            while (ax.length && bx.length) {
                var an = ax.shift();
                var bn = bx.shift();
                var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
                if (nn) return nn;
            }

            return ax.length - bx.length;
        },
        startTimer: function () {
            if (this.DEBUG) this.timer = Date.now();
        },
        endTimer: function () {
            if (this.DEBUG) {
                var offset = Date.now() - this.timer;
                console.info('Filter processed in ' + offset + 'ms.')
            }
        },
        log: (function (message) {
            if (this.DEBUG) console.info(message);
        })
    };

    window.ShopifyFilter = ShopifyFilter;

    // Allow instantiation via jQuery.
    $.fn.shopifyFilter = function (params) {
        return new ShopifyFilter(this, params);
    };
})(jQuery);




/* ============================================== THIRD PARTY ============================================== */




Handlebars.registerHelper('productLink', function (handle) {
    if (window.location.pathname != '/search' && window.location.pathname != '/') {
        return window.location.pathname + '/products/' + handle;
    } else {
        return '/products/' + handle;
    }
});


Handlebars.registerHelper('productPrice', function (product) {
    var price = null;
    var priceFloat = null;
    var priceVaries = false;
    var compareAtPriceVaries = false;
    var minCompareAtPrice = null;
    var minCompareAtPriceFloat = null;
    var isDiscounted = false;
    var isAvailable = false;
    for (var i = 0, l = product.variants.length; i < l; i++) {
        var thisVariant = product.variants[i];
        if (thisVariant.available) {
            isAvailable = true;
        }

        var compareAtPriceFloat = parseFloat(thisVariant.compare_at_price);
        if (thisVariant.compare_at_price !== null && minCompareAtPrice === null || (thisVariant.compare_at_price !== null && compareAtPriceFloat < minCompareAtPriceFloat)) {
            minCompareAtPrice = thisVariant.compare_at_price;
            minCompareAtPriceFloat = compareAtPriceFloat;
            isDiscounted = true;
        }

        if (thisVariant.compare_at_price !== null && minCompareAtPriceFloat !== compareAtPriceFloat) {
            compareAtPriceVaries = true;
        }

        var variantPriceFloat = parseFloat(thisVariant.price);
        if (price === null || variantPriceFloat < price) {
            price = thisVariant.price;
            priceFloat = variantPriceFloat;
        }

        if (priceFloat !== variantPriceFloat) {
            priceVaries = true;
        }
    }

    if (isDiscounted) {
        if (priceVaries && false) {
            return 'From ' + Shopify.formatMoney(price);
        } else {
            return new Handlebars.SafeString('<span class="visually-hidden">Regular price</span> <s>' + Shopify.formatMoney(minCompareAtPrice) + '</s> ' + Shopify.formatMoney(price));
        }
    } else {
        if (priceVaries && false) {
            return 'From ' + Shopify.formatMoney(price);
        } else {
            return Shopify.formatMoney(price);
        }
    }
});


Handlebars.registerHelper('imageLink', function (link, options) {
    if (link) {
        if (link.src) {
            return Shopify.resizeImage(link.src, options.hash.size);
        } else {
            return Shopify.resizeImage(link, options.hash.size);
        }
    }
});


Handlebars.registerHelper('moneyFormat', function (price) {
  	Shopify.money_format = "{{amount}}€"
    return Shopify.formatMoney(price);
});


Handlebars.registerHelper('hasColours', function (productOptions, options) {
    if (productOptions) {
        for (var i = 0, l = productOptions.length; i < l; i++) {
            var option = productOptions[i];
            if (option.name == 'Colour' || option.name == 'Color') {
                if (option.values.length > 1) {
                    return options.fn(this);
                }
                break;
            }
        }
    }

    return options.inverse(this);
});


Handlebars.registerHelper('compare', function (lvalue, rvalue, options) {
    if (arguments.length < 3) {
        throw new Error('Handlerbars Helper \'compare\' needs 2 parameters');
    }

    if (typeof lvalue == 'undefined' || typeof rvalue == 'undefined') {
        return false;
    }

    var operator = options.hash.operator || '==';
    var operators = {
        '==': function (l, r) {
            return l == r;
        },
        '===': function (l, r) {
            return l === r;
        },
        '!=': function (l, r) {
            return l != r;
        },
        '<': function (l, r) {
            return parseFloat(l) < parseFloat(r);
        },
        '>': function (l, r) {
            return parseFloat(l) > parseFloat(r);
        },
        '<=': function (l, r) {
            return parseFloat(l) <= parseFloat(r);
        },
        '>=': function (l, r) {
            return parseFloat(l) >= parseFloat(r);
        },
        'typeof': function (l, r) {
            return typeof l == r;
        },
        'contains': function (l, r) {
            return ~l.indexOf(r);
        },
        '!contains': function (l, r) {
            return !(~l.indexOf(r));
        }
    };

    if (!operators[operator]) {
        throw new Error('Handlerbars Helper \'compare\' doesn\'t know the operator ' + operator);
    }

    var result = operators[operator](lvalue, rvalue);

    if (result) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});


/**
 * simplePagination.js v1.6
 * A simple jQuery pagination plugin.
 * http://flaviusmatis.github.com/simplePagination.js/
 *
 * Copyright 2012, Flavius Matis
 * Released under the MIT license.
 * http://flaviusmatis.github.com/license.html
 */

(function($){

    var methods = {
        init: function(options) {
            var o = $.extend({
                items: 1,
                itemsOnPage: 1,
                pages: 0,
                displayedPages: 5,
                edges: 2,
                currentPage: 0,
                hrefTextPrefix: '#page-',
                hrefTextSuffix: '',
                prevText: 'Prev',
                nextText: 'Next',
                ellipseText: '&hellip;',
                ellipsePageSet: true,
                cssStyle: 'light-theme',
                listStyle: '',
                labelMap: [],
                selectOnClick: true,
                nextAtFront: false,
                invertPageOrder: false,
                useStartEdge : true,
                useEndEdge : true,
                onPageClick: function(pageNumber, event) {
                    // Callback triggered when a page is clicked
                    // Page number is given as an optional parameter
                },
                onInit: function() {
                    // Callback triggered immediately after initialization
                }
            }, options || {});

            var self = this;

            o.pages = o.pages ? o.pages : Math.ceil(o.items / o.itemsOnPage) ? Math.ceil(o.items / o.itemsOnPage) : 1;
            if (o.currentPage)
                o.currentPage = o.currentPage - 1;
            else
                o.currentPage = !o.invertPageOrder ? 0 : o.pages - 1;
            o.halfDisplayed = o.displayedPages / 2;

            this.each(function() {
                self.addClass(o.cssStyle + ' simple-pagination').data('pagination', o);
                methods._draw.call(self);
            });

            o.onInit();

            return this;
        },

        selectPage: function(page) {
            methods._selectPage.call(this, page - 1);
            return this;
        },

        prevPage: function() {
            var o = this.data('pagination');
            if (!o.invertPageOrder) {
                if (o.currentPage > 0) {
                    methods._selectPage.call(this, o.currentPage - 1);
                }
            } else {
                if (o.currentPage < o.pages - 1) {
                    methods._selectPage.call(this, o.currentPage + 1);
                }
            }
            return this;
        },

        nextPage: function() {
            var o = this.data('pagination');
            if (!o.invertPageOrder) {
                if (o.currentPage < o.pages - 1) {
                    methods._selectPage.call(this, o.currentPage + 1);
                }
            } else {
                if (o.currentPage > 0) {
                    methods._selectPage.call(this, o.currentPage - 1);
                }
            }
            return this;
        },

        getPagesCount: function() {
            return this.data('pagination').pages;
        },

        setPagesCount: function(count) {
            this.data('pagination').pages = count;
        },

        getCurrentPage: function () {
            return this.data('pagination').currentPage + 1;
        },

        destroy: function(){
            this.empty();
            return this;
        },

        drawPage: function (page) {
            var o = this.data('pagination');
            o.currentPage = page - 1;
            this.data('pagination', o);
            methods._draw.call(this);
            return this;
        },

        redraw: function(){
            methods._draw.call(this);
            return this;
        },

        disable: function(){
            var o = this.data('pagination');
            o.disabled = true;
            this.data('pagination', o);
            methods._draw.call(this);
            return this;
        },

        enable: function(){
            var o = this.data('pagination');
            o.disabled = false;
            this.data('pagination', o);
            methods._draw.call(this);
            return this;
        },

        updateItems: function (newItems) {
            var o = this.data('pagination');
            o.items = newItems;
            o.pages = methods._getPages(o);
            this.data('pagination', o);
            methods._draw.call(this);
        },

        updateItemsOnPage: function (itemsOnPage) {
            var o = this.data('pagination');
            o.itemsOnPage = itemsOnPage;
            o.pages = methods._getPages(o);
            this.data('pagination', o);
            methods._draw.call(this);
            return this;
        },

        getItemsOnPage: function() {
            return this.data('pagination').itemsOnPage;
        },

        _draw: function() {
            var	o = this.data('pagination'),
                interval = methods._getInterval(o),
                i,
                tagName;

            methods.destroy.call(this);

            tagName = (typeof this.prop === 'function') ? this.prop('tagName') : this.attr('tagName');

            var $panel = tagName === 'UL' ? this : $('<ul id="pagination"' + (o.listStyle ? ' class="' + o.listStyle + '"' : '') + '></ul>').appendTo(this);

            // Generate Prev link
            if (o.prevText) {
                methods._appendItem.call(this, !o.invertPageOrder ? o.currentPage - 1 : o.currentPage + 1, {text: o.prevText, classes: 'prev'});
            }

            // Generate Next link (if option set for at front)
            if (o.nextText && o.nextAtFront) {
                methods._appendItem.call(this, !o.invertPageOrder ? o.currentPage + 1 : o.currentPage - 1, {text: o.nextText, classes: 'next'});
            }

            // Generate start edges
            if (!o.invertPageOrder) {
                if (interval.start > 0 && o.edges > 0) {
                    if(o.useStartEdge) {
                        var end = Math.min(o.edges, interval.start);
                        for (i = 0; i < end; i++) {
                            methods._appendItem.call(this, i);
                        }
                    }
                    if (o.edges < interval.start && (interval.start - o.edges != 1)) {
                        $panel.append('<li class="disabled"><span class="paginate-note">' + o.ellipseText + '</span></li>');
                    } else if (interval.start - o.edges == 1) {
                        methods._appendItem.call(this, o.edges);
                    }
                }
            } else {
                if (interval.end < o.pages && o.edges > 0) {
                    if(o.useStartEdge) {
                        var begin = Math.max(o.pages - o.edges, interval.end);
                        for (i = o.pages - 1; i >= begin; i--) {
                            methods._appendItem.call(this, i);
                        }
                    }

                    if (o.pages - o.edges > interval.end && (o.pages - o.edges - interval.end != 1)) {
                        $panel.append('<li class="disabled"><span class="paginate-note">' + o.ellipseText + '</span></li>');
                    } else if (o.pages - o.edges - interval.end == 1) {
                        methods._appendItem.call(this, interval.end);
                    }
                }
            }

            // Generate interval links
            if (!o.invertPageOrder) {
                for (i = interval.start; i < interval.end; i++) {
                    methods._appendItem.call(this, i);
                }
            } else {
                for (i = interval.end - 1; i >= interval.start; i--) {
                    methods._appendItem.call(this, i);
                }
            }

            // Generate end edges
            if (!o.invertPageOrder) {
                if (interval.end < o.pages && o.edges > 0) {
                    if (o.pages - o.edges > interval.end && (o.pages - o.edges - interval.end != 1)) {
                        $panel.append('<li class="disabled"><span class="paginate-note">' + o.ellipseText + '</span></li>');
                    } else if (o.pages - o.edges - interval.end == 1) {
                        methods._appendItem.call(this, interval.end);
                    }
                    if(o.useEndEdge) {
                        var begin = Math.max(o.pages - o.edges, interval.end);
                        for (i = begin; i < o.pages; i++) {
                            methods._appendItem.call(this, i);
                        }
                    }
                }
            } else {
                if (interval.start > 0 && o.edges > 0) {
                    if (o.edges < interval.start && (interval.start - o.edges != 1)) {
                        $panel.append('<li class="disabled"><span class="paginate-note">' + o.ellipseText + '</span></li>');
                    } else if (interval.start - o.edges == 1) {
                        methods._appendItem.call(this, o.edges);
                    }

                    if(o.useEndEdge) {
                        var end = Math.min(o.edges, interval.start);
                        for (i = end - 1; i >= 0; i--) {
                            methods._appendItem.call(this, i);
                        }
                    }
                }
            }

            // Generate Next link (unless option is set for at front)
            if (o.nextText && !o.nextAtFront) {
                methods._appendItem.call(this, !o.invertPageOrder ? o.currentPage + 1 : o.currentPage - 1, {text: o.nextText, classes: 'next'});
            }

            if (o.ellipsePageSet && !o.disabled) {
                methods._ellipseClick.call(this, $panel);
            }

        },

        _getPages: function(o) {
            var pages = Math.ceil(o.items / o.itemsOnPage);
            return pages || 1;
        },

        _getInterval: function(o) {
            return {
                start: Math.ceil(o.currentPage > o.halfDisplayed ? Math.max(Math.min(o.currentPage - o.halfDisplayed, (o.pages - o.displayedPages)), 0) : 0),
                end: Math.ceil(o.currentPage > o.halfDisplayed ? Math.min(o.currentPage + o.halfDisplayed, o.pages) : Math.min(o.displayedPages, o.pages))
            };
        },

        _appendItem: function(pageIndex, opts) {
            var self = this, options, $link, o = self.data('pagination'), $linkWrapper = $('<li></li>'), $ul = self.find('ul');

            pageIndex = pageIndex < 0 ? 0 : (pageIndex < o.pages ? pageIndex : o.pages - 1);

            options = {
                text: pageIndex + 1,
                classes: ''
            };

            if (o.labelMap.length && o.labelMap[pageIndex]) {
                options.text = o.labelMap[pageIndex];
            }

            options = $.extend(options, opts || {});

            if (pageIndex == o.currentPage || o.disabled) {
                if (o.disabled || options.classes === 'prev' || options.classes === 'next') {
                    if (options.classes === 'prev' || options.classes === 'next') {
                        $link = $('<a href="#" class="active disabled ' + options.classes + '" rel="' + options.classes + '">' + (options.text) + '</a>');
                    } else {
                        $link = $('<a href="#" class="active disabled ' + options.classes + '">' + (options.text) + '</a>');
                    }
                } else {
                    $link = $('<span class="paginate-note">' + (options.text) + '</span>');
                }
            } else {
                $link = $('<a href="' + o.hrefTextPrefix + (pageIndex + 1) + o.hrefTextSuffix + '" class="page-link">' + (options.text) + '</a>');
                $link.click(function(event){
                    return methods._selectPage.call(self, pageIndex, event);
                });
            }

            if (options.classes) {
                $link.addClass(options.classes);
            }

            $linkWrapper.append($link);

            if ($ul.length) {
                $ul.append($linkWrapper);
            } else {
                self.append($linkWrapper);
            }
        },

        _selectPage: function(pageIndex, event) {
            var o = this.data('pagination');
            o.currentPage = pageIndex;
            if (o.selectOnClick) {
                methods._draw.call(this);
            }
            return o.onPageClick(pageIndex + 1, event);
        },


        _ellipseClick: function($panel) {
            var self = this,
                o = this.data('pagination'),
                $ellip = $panel.find('.ellipse');
            $ellip.addClass('clickable').parent().removeClass('disabled');
            $ellip.click(function(event) {
                if (!o.disable) {
                    var $this = $(this),
                        val = (parseInt($this.parent().prev().text(), 10) || 0) + 1;
                    $this
                        .html('<input type="number" min="1" max="' + o.pages + '" step="1" value="' + val + '">')
                        .find('input')
                        .focus()
                        .click(function(event) {
                            // prevent input number arrows from bubbling a click event on $ellip
                            event.stopPropagation();
                        })
                        .keyup(function(event) {
                            var val = $(this).val();
                            if (event.which === 13 && val !== '') {
                                // enter to accept
                                if ((val>0)&&(val<=o.pages))
                                    methods._selectPage.call(self, val - 1);
                            } else if (event.which === 27) {
                                // escape to cancel
                                $ellip.empty().html(o.ellipseText);
                            }
                        })
                        .bind('blur', function(event) {
                            var val = $(this).val();
                            if (val !== '') {
                                methods._selectPage.call(self, val - 1);
                            }
                            $ellip.empty().html(o.ellipseText);
                            return false;
                        });
                }
                return false;
            });
        }

    };

    $.fn.pagination = function(method) {

        // Method calling logic
        if (methods[method] && method.charAt(0) != '_') {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' +  method + ' does not exist on jQuery.pagination');
        }

    };

})(jQuery);

// Ion.RangeSlider | version 2.1.4 | https://github.com/IonDen/ion.rangeSlider
;(function(g){"function"===typeof define&&define.amd?define(["jquery"],function(q){g(q,document,window,navigator)}):g(jQuery,document,window,navigator)})(function(g,q,h,t,v){var u=0,p=function(){var a=t.userAgent,b=/msie\s\d+/i;return 0<a.search(b)&&(a=b.exec(a).toString(),a=a.split(" ")[1],9>a)?(g("html").addClass("lt-ie9"),!0):!1}();Function.prototype.bind||(Function.prototype.bind=function(a){var b=this,d=[].slice;if("function"!=typeof b)throw new TypeError;var c=d.call(arguments,1),e=function(){if(this instanceof
    e){var f=function(){};f.prototype=b.prototype;var f=new f,l=b.apply(f,c.concat(d.call(arguments)));return Object(l)===l?l:f}return b.apply(a,c.concat(d.call(arguments)))};return e});Array.prototype.indexOf||(Array.prototype.indexOf=function(a,b){var d;if(null==this)throw new TypeError('"this" is null or not defined');var c=Object(this),e=c.length>>>0;if(0===e)return-1;d=+b||0;Infinity===Math.abs(d)&&(d=0);if(d>=e)return-1;for(d=Math.max(0<=d?d:e-Math.abs(d),0);d<e;){if(d in c&&c[d]===a)return d;d++}return-1});
    var r=function(a,b,d){this.VERSION="2.1.4";this.input=a;this.plugin_count=d;this.old_to=this.old_from=this.update_tm=this.calc_count=this.current_plugin=0;this.raf_id=this.old_min_interval=null;this.is_update=this.is_key=this.no_diapason=this.force_redraw=this.dragging=!1;this.is_start=!0;this.is_click=this.is_resize=this.is_active=this.is_finish=!1;this.$cache={win:g(h),body:g(q.body),input:g(a),cont:null,rs:null,min:null,max:null,from:null,to:null,single:null,bar:null,line:null,s_single:null,s_from:null,
        s_to:null,shad_single:null,shad_from:null,shad_to:null,edge:null,grid:null,grid_labels:[]};this.coords={x_gap:0,x_pointer:0,w_rs:0,w_rs_old:0,w_handle:0,p_gap:0,p_gap_left:0,p_gap_right:0,p_step:0,p_pointer:0,p_handle:0,p_single_fake:0,p_single_real:0,p_from_fake:0,p_from_real:0,p_to_fake:0,p_to_real:0,p_bar_x:0,p_bar_w:0,grid_gap:0,big_num:0,big:[],big_w:[],big_p:[],big_x:[]};this.labels={w_min:0,w_max:0,w_from:0,w_to:0,w_single:0,p_min:0,p_max:0,p_from_fake:0,p_from_left:0,p_to_fake:0,p_to_left:0,
        p_single_fake:0,p_single_left:0};var c=this.$cache.input;a=c.prop("value");var e;d={type:"single",min:10,max:100,from:null,to:null,step:1,min_interval:0,max_interval:0,drag_interval:!1,values:[],p_values:[],from_fixed:!1,from_min:null,from_max:null,from_shadow:!1,to_fixed:!1,to_min:null,to_max:null,to_shadow:!1,prettify_enabled:!0,prettify_separator:" ",prettify:null,force_edges:!1,keyboard:!1,keyboard_step:5,grid:!1,grid_margin:!0,grid_num:4,grid_snap:!1,hide_min_max:!1,hide_from_to:!1,prefix:"",
        postfix:"",max_postfix:"",decorate_both:!0,values_separator:" \u2014 ",input_values_separator:";",disable:!1,onStart:null,onChange:null,onFinish:null,onUpdate:null};c={type:c.data("type"),min:c.data("min"),max:c.data("max"),from:c.data("from"),to:c.data("to"),step:c.data("step"),min_interval:c.data("minInterval"),max_interval:c.data("maxInterval"),drag_interval:c.data("dragInterval"),values:c.data("values"),from_fixed:c.data("fromFixed"),from_min:c.data("fromMin"),from_max:c.data("fromMax"),from_shadow:c.data("fromShadow"),
        to_fixed:c.data("toFixed"),to_min:c.data("toMin"),to_max:c.data("toMax"),to_shadow:c.data("toShadow"),prettify_enabled:c.data("prettifyEnabled"),prettify_separator:c.data("prettifySeparator"),force_edges:c.data("forceEdges"),keyboard:c.data("keyboard"),keyboard_step:c.data("keyboardStep"),grid:c.data("grid"),grid_margin:c.data("gridMargin"),grid_num:c.data("gridNum"),grid_snap:c.data("gridSnap"),hide_min_max:c.data("hideMinMax"),hide_from_to:c.data("hideFromTo"),prefix:c.data("prefix"),postfix:c.data("postfix"),
        max_postfix:c.data("maxPostfix"),decorate_both:c.data("decorateBoth"),values_separator:c.data("valuesSeparator"),input_values_separator:c.data("inputValuesSeparator"),disable:c.data("disable")};c.values=c.values&&c.values.split(",");for(e in c)c.hasOwnProperty(e)&&(c[e]||0===c[e]||delete c[e]);a&&(a=a.split(c.input_values_separator||b.input_values_separator||";"),a[0]&&a[0]==+a[0]&&(a[0]=+a[0]),a[1]&&a[1]==+a[1]&&(a[1]=+a[1]),b&&b.values&&b.values.length?(d.from=a[0]&&b.values.indexOf(a[0]),d.to=
        a[1]&&b.values.indexOf(a[1])):(d.from=a[0]&&+a[0],d.to=a[1]&&+a[1]));g.extend(d,b);g.extend(d,c);this.options=d;this.validate();this.result={input:this.$cache.input,slider:null,min:this.options.min,max:this.options.max,from:this.options.from,from_percent:0,from_value:null,to:this.options.to,to_percent:0,to_value:null};this.init()};r.prototype={init:function(a){this.no_diapason=!1;this.coords.p_step=this.convertToPercent(this.options.step,!0);this.target="base";this.toggleInput();this.append();this.setMinMax();
        a?(this.force_redraw=!0,this.calc(!0),this.callOnUpdate()):(this.force_redraw=!0,this.calc(!0),this.callOnStart());this.updateScene()},append:function(){this.$cache.input.before('<span class="irs js-irs-'+this.plugin_count+'"></span>');this.$cache.input.prop("readonly",!0);this.$cache.cont=this.$cache.input.prev();this.result.slider=this.$cache.cont;this.$cache.cont.html('<span class="irs"><span class="irs-line" tabindex="-1"><span class="irs-line-left"></span><span class="irs-line-mid"></span><span class="irs-line-right"></span></span><span class="irs-min">0</span><span class="irs-max">1</span><span class="irs-from">0</span><span class="irs-to">0</span><span class="irs-single">0</span></span><span class="irs-grid"></span><span class="irs-bar"></span>');
        this.$cache.rs=this.$cache.cont.find(".irs");this.$cache.min=this.$cache.cont.find(".irs-min");this.$cache.max=this.$cache.cont.find(".irs-max");this.$cache.from=this.$cache.cont.find(".irs-from");this.$cache.to=this.$cache.cont.find(".irs-to");this.$cache.single=this.$cache.cont.find(".irs-single");this.$cache.bar=this.$cache.cont.find(".irs-bar");this.$cache.line=this.$cache.cont.find(".irs-line");this.$cache.grid=this.$cache.cont.find(".irs-grid");"single"===this.options.type?(this.$cache.cont.append('<span class="irs-bar-edge"></span><span class="irs-shadow shadow-single"></span><span class="irs-slider single"></span>'),
            this.$cache.edge=this.$cache.cont.find(".irs-bar-edge"),this.$cache.s_single=this.$cache.cont.find(".single"),this.$cache.from[0].style.visibility="hidden",this.$cache.to[0].style.visibility="hidden",this.$cache.shad_single=this.$cache.cont.find(".shadow-single")):(this.$cache.cont.append('<span class="irs-shadow shadow-from"></span><span class="irs-shadow shadow-to"></span><span class="irs-slider from"></span><span class="irs-slider to"></span>'),this.$cache.s_from=this.$cache.cont.find(".from"),
            this.$cache.s_to=this.$cache.cont.find(".to"),this.$cache.shad_from=this.$cache.cont.find(".shadow-from"),this.$cache.shad_to=this.$cache.cont.find(".shadow-to"),this.setTopHandler());this.options.hide_from_to&&(this.$cache.from[0].style.display="none",this.$cache.to[0].style.display="none",this.$cache.single[0].style.display="none");this.appendGrid();this.options.disable?(this.appendDisableMask(),this.$cache.input[0].disabled=!0):(this.$cache.cont.removeClass("irs-disabled"),this.$cache.input[0].disabled=
            !1,this.bindEvents());this.options.drag_interval&&(this.$cache.bar[0].style.cursor="ew-resize")},setTopHandler:function(){var a=this.options.max,b=this.options.to;this.options.from>this.options.min&&b===a?this.$cache.s_from.addClass("type_last"):b<a&&this.$cache.s_to.addClass("type_last")},changeLevel:function(a){switch(a){case "single":this.coords.p_gap=this.toFixed(this.coords.p_pointer-this.coords.p_single_fake);break;case "from":this.coords.p_gap=this.toFixed(this.coords.p_pointer-this.coords.p_from_fake);
        this.$cache.s_from.addClass("state_hover");this.$cache.s_from.addClass("type_last");this.$cache.s_to.removeClass("type_last");break;case "to":this.coords.p_gap=this.toFixed(this.coords.p_pointer-this.coords.p_to_fake);this.$cache.s_to.addClass("state_hover");this.$cache.s_to.addClass("type_last");this.$cache.s_from.removeClass("type_last");break;case "both":this.coords.p_gap_left=this.toFixed(this.coords.p_pointer-this.coords.p_from_fake),this.coords.p_gap_right=this.toFixed(this.coords.p_to_fake-
        this.coords.p_pointer),this.$cache.s_to.removeClass("type_last"),this.$cache.s_from.removeClass("type_last")}},appendDisableMask:function(){this.$cache.cont.append('<span class="irs-disable-mask"></span>');this.$cache.cont.addClass("irs-disabled")},remove:function(){this.$cache.cont.remove();this.$cache.cont=null;this.$cache.line.off("keydown.irs_"+this.plugin_count);this.$cache.body.off("touchmove.irs_"+this.plugin_count);this.$cache.body.off("mousemove.irs_"+this.plugin_count);this.$cache.win.off("touchend.irs_"+
        this.plugin_count);this.$cache.win.off("mouseup.irs_"+this.plugin_count);p&&(this.$cache.body.off("mouseup.irs_"+this.plugin_count),this.$cache.body.off("mouseleave.irs_"+this.plugin_count));this.$cache.grid_labels=[];this.coords.big=[];this.coords.big_w=[];this.coords.big_p=[];this.coords.big_x=[];cancelAnimationFrame(this.raf_id)},bindEvents:function(){if(!this.no_diapason){this.$cache.body.on("touchmove.irs_"+this.plugin_count,this.pointerMove.bind(this));this.$cache.body.on("mousemove.irs_"+this.plugin_count,
        this.pointerMove.bind(this));this.$cache.win.on("touchend.irs_"+this.plugin_count,this.pointerUp.bind(this));this.$cache.win.on("mouseup.irs_"+this.plugin_count,this.pointerUp.bind(this));this.$cache.line.on("touchstart.irs_"+this.plugin_count,this.pointerClick.bind(this,"click"));this.$cache.line.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click"));this.options.drag_interval&&"double"===this.options.type?(this.$cache.bar.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,
        "both")),this.$cache.bar.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"both"))):(this.$cache.bar.on("touchstart.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.bar.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")));"single"===this.options.type?(this.$cache.single.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"single")),this.$cache.s_single.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"single")),
        this.$cache.shad_single.on("touchstart.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.single.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"single")),this.$cache.s_single.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"single")),this.$cache.edge.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.shad_single.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click"))):(this.$cache.single.on("touchstart.irs_"+
        this.plugin_count,this.pointerDown.bind(this,null)),this.$cache.single.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,null)),this.$cache.from.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"from")),this.$cache.s_from.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"from")),this.$cache.to.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"to")),this.$cache.s_to.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"to")),
        this.$cache.shad_from.on("touchstart.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.shad_to.on("touchstart.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.from.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"from")),this.$cache.s_from.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"from")),this.$cache.to.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"to")),this.$cache.s_to.on("mousedown.irs_"+
        this.plugin_count,this.pointerDown.bind(this,"to")),this.$cache.shad_from.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.shad_to.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")));if(this.options.keyboard)this.$cache.line.on("keydown.irs_"+this.plugin_count,this.key.bind(this,"keyboard"));p&&(this.$cache.body.on("mouseup.irs_"+this.plugin_count,this.pointerUp.bind(this)),this.$cache.body.on("mouseleave.irs_"+this.plugin_count,this.pointerUp.bind(this)))}},
        pointerMove:function(a){this.dragging&&(this.coords.x_pointer=(a.pageX||a.originalEvent.touches&&a.originalEvent.touches[0].pageX)-this.coords.x_gap,this.calc())},pointerUp:function(a){if(this.current_plugin===this.plugin_count&&this.is_active){this.is_active=!1;this.$cache.cont.find(".state_hover").removeClass("state_hover");this.force_redraw=!0;p&&g("*").prop("unselectable",!1);this.updateScene();this.restoreOriginalMinInterval();if(g.contains(this.$cache.cont[0],a.target)||this.dragging)this.is_finish=
            !0,this.callOnFinish();this.dragging=!1}},pointerDown:function(a,b){b.preventDefault();var d=b.pageX||b.originalEvent.touches&&b.originalEvent.touches[0].pageX;2!==b.button&&("both"===a&&this.setTempMinInterval(),a||(a=this.target),this.current_plugin=this.plugin_count,this.target=a,this.dragging=this.is_active=!0,this.coords.x_gap=this.$cache.rs.offset().left,this.coords.x_pointer=d-this.coords.x_gap,this.calcPointerPercent(),this.changeLevel(a),p&&g("*").prop("unselectable",!0),this.$cache.line.trigger("focus"),
            this.updateScene())},pointerClick:function(a,b){b.preventDefault();var d=b.pageX||b.originalEvent.touches&&b.originalEvent.touches[0].pageX;2!==b.button&&(this.current_plugin=this.plugin_count,this.target=a,this.is_click=!0,this.coords.x_gap=this.$cache.rs.offset().left,this.coords.x_pointer=+(d-this.coords.x_gap).toFixed(),this.force_redraw=!0,this.calc(),this.$cache.line.trigger("focus"))},key:function(a,b){if(!(this.current_plugin!==this.plugin_count||b.altKey||b.ctrlKey||b.shiftKey||b.metaKey)){switch(b.which){case 83:case 65:case 40:case 37:b.preventDefault();
            this.moveByKey(!1);break;case 87:case 68:case 38:case 39:b.preventDefault(),this.moveByKey(!0)}return!0}},moveByKey:function(a){var b=this.coords.p_pointer,b=a?b+this.options.keyboard_step:b-this.options.keyboard_step;this.coords.x_pointer=this.toFixed(this.coords.w_rs/100*b);this.is_key=!0;this.calc()},setMinMax:function(){this.options&&(this.options.hide_min_max?(this.$cache.min[0].style.display="none",this.$cache.max[0].style.display="none"):(this.options.values.length?(this.$cache.min.html(this.decorate(this.options.p_values[this.options.min])),
            this.$cache.max.html(this.decorate(this.options.p_values[this.options.max]))):(this.$cache.min.html(this.decorate(this._prettify(this.options.min),this.options.min)),this.$cache.max.html(this.decorate(this._prettify(this.options.max),this.options.max))),this.labels.w_min=this.$cache.min.outerWidth(!1),this.labels.w_max=this.$cache.max.outerWidth(!1)))},setTempMinInterval:function(){var a=this.result.to-this.result.from;null===this.old_min_interval&&(this.old_min_interval=this.options.min_interval);
            this.options.min_interval=a},restoreOriginalMinInterval:function(){null!==this.old_min_interval&&(this.options.min_interval=this.old_min_interval,this.old_min_interval=null)},calc:function(a){if(this.options){this.calc_count++;if(10===this.calc_count||a)this.calc_count=0,this.coords.w_rs=this.$cache.rs.outerWidth(!1),this.calcHandlePercent();if(this.coords.w_rs){this.calcPointerPercent();a=this.getHandleX();"click"===this.target&&(this.coords.p_gap=this.coords.p_handle/2,a=this.getHandleX(),this.target=
            this.options.drag_interval?"both_one":this.chooseHandle(a));switch(this.target){case "base":var b=(this.options.max-this.options.min)/100;a=(this.result.from-this.options.min)/b;b=(this.result.to-this.options.min)/b;this.coords.p_single_real=this.toFixed(a);this.coords.p_from_real=this.toFixed(a);this.coords.p_to_real=this.toFixed(b);this.coords.p_single_real=this.checkDiapason(this.coords.p_single_real,this.options.from_min,this.options.from_max);this.coords.p_from_real=this.checkDiapason(this.coords.p_from_real,
            this.options.from_min,this.options.from_max);this.coords.p_to_real=this.checkDiapason(this.coords.p_to_real,this.options.to_min,this.options.to_max);this.coords.p_single_fake=this.convertToFakePercent(this.coords.p_single_real);this.coords.p_from_fake=this.convertToFakePercent(this.coords.p_from_real);this.coords.p_to_fake=this.convertToFakePercent(this.coords.p_to_real);this.target=null;break;case "single":if(this.options.from_fixed)break;this.coords.p_single_real=this.convertToRealPercent(a);this.coords.p_single_real=
            this.calcWithStep(this.coords.p_single_real);this.coords.p_single_real=this.checkDiapason(this.coords.p_single_real,this.options.from_min,this.options.from_max);this.coords.p_single_fake=this.convertToFakePercent(this.coords.p_single_real);break;case "from":if(this.options.from_fixed)break;this.coords.p_from_real=this.convertToRealPercent(a);this.coords.p_from_real=this.calcWithStep(this.coords.p_from_real);this.coords.p_from_real>this.coords.p_to_real&&(this.coords.p_from_real=this.coords.p_to_real);
            this.coords.p_from_real=this.checkDiapason(this.coords.p_from_real,this.options.from_min,this.options.from_max);this.coords.p_from_real=this.checkMinInterval(this.coords.p_from_real,this.coords.p_to_real,"from");this.coords.p_from_real=this.checkMaxInterval(this.coords.p_from_real,this.coords.p_to_real,"from");this.coords.p_from_fake=this.convertToFakePercent(this.coords.p_from_real);break;case "to":if(this.options.to_fixed)break;this.coords.p_to_real=this.convertToRealPercent(a);this.coords.p_to_real=
            this.calcWithStep(this.coords.p_to_real);this.coords.p_to_real<this.coords.p_from_real&&(this.coords.p_to_real=this.coords.p_from_real);this.coords.p_to_real=this.checkDiapason(this.coords.p_to_real,this.options.to_min,this.options.to_max);this.coords.p_to_real=this.checkMinInterval(this.coords.p_to_real,this.coords.p_from_real,"to");this.coords.p_to_real=this.checkMaxInterval(this.coords.p_to_real,this.coords.p_from_real,"to");this.coords.p_to_fake=this.convertToFakePercent(this.coords.p_to_real);
            break;case "both":if(this.options.from_fixed||this.options.to_fixed)break;a=this.toFixed(a+.1*this.coords.p_handle);this.coords.p_from_real=this.convertToRealPercent(a)-this.coords.p_gap_left;this.coords.p_from_real=this.calcWithStep(this.coords.p_from_real);this.coords.p_from_real=this.checkDiapason(this.coords.p_from_real,this.options.from_min,this.options.from_max);this.coords.p_from_real=this.checkMinInterval(this.coords.p_from_real,this.coords.p_to_real,"from");this.coords.p_from_fake=this.convertToFakePercent(this.coords.p_from_real);
            this.coords.p_to_real=this.convertToRealPercent(a)+this.coords.p_gap_right;this.coords.p_to_real=this.calcWithStep(this.coords.p_to_real);this.coords.p_to_real=this.checkDiapason(this.coords.p_to_real,this.options.to_min,this.options.to_max);this.coords.p_to_real=this.checkMinInterval(this.coords.p_to_real,this.coords.p_from_real,"to");this.coords.p_to_fake=this.convertToFakePercent(this.coords.p_to_real);break;case "both_one":if(!this.options.from_fixed&&!this.options.to_fixed){var d=this.convertToRealPercent(a);
            a=this.result.to_percent-this.result.from_percent;var c=a/2,b=d-c,d=d+c;0>b&&(b=0,d=b+a);100<d&&(d=100,b=d-a);this.coords.p_from_real=this.calcWithStep(b);this.coords.p_from_real=this.checkDiapason(this.coords.p_from_real,this.options.from_min,this.options.from_max);this.coords.p_from_fake=this.convertToFakePercent(this.coords.p_from_real);this.coords.p_to_real=this.calcWithStep(d);this.coords.p_to_real=this.checkDiapason(this.coords.p_to_real,this.options.to_min,this.options.to_max);this.coords.p_to_fake=
                this.convertToFakePercent(this.coords.p_to_real)}}"single"===this.options.type?(this.coords.p_bar_x=this.coords.p_handle/2,this.coords.p_bar_w=this.coords.p_single_fake,this.result.from_percent=this.coords.p_single_real,this.result.from=this.convertToValue(this.coords.p_single_real),this.options.values.length&&(this.result.from_value=this.options.values[this.result.from])):(this.coords.p_bar_x=this.toFixed(this.coords.p_from_fake+this.coords.p_handle/2),this.coords.p_bar_w=this.toFixed(this.coords.p_to_fake-
            this.coords.p_from_fake),this.result.from_percent=this.coords.p_from_real,this.result.from=this.convertToValue(this.coords.p_from_real),this.result.to_percent=this.coords.p_to_real,this.result.to=this.convertToValue(this.coords.p_to_real),this.options.values.length&&(this.result.from_value=this.options.values[this.result.from],this.result.to_value=this.options.values[this.result.to]));this.calcMinMax();this.calcLabels()}}},calcPointerPercent:function(){this.coords.w_rs?(0>this.coords.x_pointer||isNaN(this.coords.x_pointer)?
            this.coords.x_pointer=0:this.coords.x_pointer>this.coords.w_rs&&(this.coords.x_pointer=this.coords.w_rs),this.coords.p_pointer=this.toFixed(this.coords.x_pointer/this.coords.w_rs*100)):this.coords.p_pointer=0},convertToRealPercent:function(a){return a/(100-this.coords.p_handle)*100},convertToFakePercent:function(a){return a/100*(100-this.coords.p_handle)},getHandleX:function(){var a=100-this.coords.p_handle,b=this.toFixed(this.coords.p_pointer-this.coords.p_gap);0>b?b=0:b>a&&(b=a);return b},calcHandlePercent:function(){this.coords.w_handle=
            "single"===this.options.type?this.$cache.s_single.outerWidth(!1):this.$cache.s_from.outerWidth(!1);this.coords.p_handle=this.toFixed(this.coords.w_handle/this.coords.w_rs*100)},chooseHandle:function(a){return"single"===this.options.type?"single":a>=this.coords.p_from_real+(this.coords.p_to_real-this.coords.p_from_real)/2?this.options.to_fixed?"from":"to":this.options.from_fixed?"to":"from"},calcMinMax:function(){this.coords.w_rs&&(this.labels.p_min=this.labels.w_min/this.coords.w_rs*100,this.labels.p_max=
            this.labels.w_max/this.coords.w_rs*100)},calcLabels:function(){this.coords.w_rs&&!this.options.hide_from_to&&("single"===this.options.type?(this.labels.w_single=this.$cache.single.outerWidth(!1),this.labels.p_single_fake=this.labels.w_single/this.coords.w_rs*100,this.labels.p_single_left=this.coords.p_single_fake+this.coords.p_handle/2-this.labels.p_single_fake/2):(this.labels.w_from=this.$cache.from.outerWidth(!1),this.labels.p_from_fake=this.labels.w_from/this.coords.w_rs*100,this.labels.p_from_left=
            this.coords.p_from_fake+this.coords.p_handle/2-this.labels.p_from_fake/2,this.labels.p_from_left=this.toFixed(this.labels.p_from_left),this.labels.p_from_left=this.checkEdges(this.labels.p_from_left,this.labels.p_from_fake),this.labels.w_to=this.$cache.to.outerWidth(!1),this.labels.p_to_fake=this.labels.w_to/this.coords.w_rs*100,this.labels.p_to_left=this.coords.p_to_fake+this.coords.p_handle/2-this.labels.p_to_fake/2,this.labels.p_to_left=this.toFixed(this.labels.p_to_left),this.labels.p_to_left=
            this.checkEdges(this.labels.p_to_left,this.labels.p_to_fake),this.labels.w_single=this.$cache.single.outerWidth(!1),this.labels.p_single_fake=this.labels.w_single/this.coords.w_rs*100,this.labels.p_single_left=(this.labels.p_from_left+this.labels.p_to_left+this.labels.p_to_fake)/2-this.labels.p_single_fake/2,this.labels.p_single_left=this.toFixed(this.labels.p_single_left)),this.labels.p_single_left=this.checkEdges(this.labels.p_single_left,this.labels.p_single_fake))},updateScene:function(){this.raf_id&&
        (cancelAnimationFrame(this.raf_id),this.raf_id=null);clearTimeout(this.update_tm);this.update_tm=null;this.options&&(this.drawHandles(),this.is_active?this.raf_id=requestAnimationFrame(this.updateScene.bind(this)):this.update_tm=setTimeout(this.updateScene.bind(this),300))},drawHandles:function(){this.coords.w_rs=this.$cache.rs.outerWidth(!1);if(this.coords.w_rs){this.coords.w_rs!==this.coords.w_rs_old&&(this.target="base",this.is_resize=!0);if(this.coords.w_rs!==this.coords.w_rs_old||this.force_redraw)this.setMinMax(),
            this.calc(!0),this.drawLabels(),this.options.grid&&(this.calcGridMargin(),this.calcGridLabels()),this.force_redraw=!0,this.coords.w_rs_old=this.coords.w_rs,this.drawShadow();if(this.coords.w_rs&&(this.dragging||this.force_redraw||this.is_key)){if(this.old_from!==this.result.from||this.old_to!==this.result.to||this.force_redraw||this.is_key){this.drawLabels();this.$cache.bar[0].style.left=this.coords.p_bar_x+"%";this.$cache.bar[0].style.width=this.coords.p_bar_w+"%";if("single"===this.options.type)this.$cache.s_single[0].style.left=
            this.coords.p_single_fake+"%",this.$cache.single[0].style.left=this.labels.p_single_left+"%",this.options.values.length?this.$cache.input.prop("value",this.result.from_value):this.$cache.input.prop("value",this.result.from),this.$cache.input.data("from",this.result.from);else{this.$cache.s_from[0].style.left=this.coords.p_from_fake+"%";this.$cache.s_to[0].style.left=this.coords.p_to_fake+"%";if(this.old_from!==this.result.from||this.force_redraw)this.$cache.from[0].style.left=this.labels.p_from_left+
            "%";if(this.old_to!==this.result.to||this.force_redraw)this.$cache.to[0].style.left=this.labels.p_to_left+"%";this.$cache.single[0].style.left=this.labels.p_single_left+"%";this.options.values.length?this.$cache.input.prop("value",this.result.from_value+this.options.input_values_separator+this.result.to_value):this.$cache.input.prop("value",this.result.from+this.options.input_values_separator+this.result.to);this.$cache.input.data("from",this.result.from);this.$cache.input.data("to",this.result.to)}this.old_from===
        this.result.from&&this.old_to===this.result.to||this.is_start||this.$cache.input.trigger("change");this.old_from=this.result.from;this.old_to=this.result.to;this.is_resize||this.is_update||this.is_start||this.is_finish||this.callOnChange();if(this.is_key||this.is_click)this.is_click=this.is_key=!1,this.callOnFinish();this.is_finish=this.is_resize=this.is_update=!1}this.force_redraw=this.is_click=this.is_key=this.is_start=!1}}},drawLabels:function(){if(this.options){var a=this.options.values.length,
            b=this.options.p_values,d;if(!this.options.hide_from_to)if("single"===this.options.type)a=a?this.decorate(b[this.result.from]):this.decorate(this._prettify(this.result.from),this.result.from),this.$cache.single.html(a),this.calcLabels(),this.$cache.min[0].style.visibility=this.labels.p_single_left<this.labels.p_min+1?"hidden":"visible",this.$cache.max[0].style.visibility=this.labels.p_single_left+this.labels.p_single_fake>100-this.labels.p_max-1?"hidden":"visible";else{a?(this.options.decorate_both?
            (a=this.decorate(b[this.result.from]),a+=this.options.values_separator,a+=this.decorate(b[this.result.to])):a=this.decorate(b[this.result.from]+this.options.values_separator+b[this.result.to]),d=this.decorate(b[this.result.from]),b=this.decorate(b[this.result.to])):(this.options.decorate_both?(a=this.decorate(this._prettify(this.result.from),this.result.from),a+=this.options.values_separator,a+=this.decorate(this._prettify(this.result.to),this.result.to)):a=this.decorate(this._prettify(this.result.from)+
            this.options.values_separator+this._prettify(this.result.to),this.result.to),d=this.decorate(this._prettify(this.result.from),this.result.from),b=this.decorate(this._prettify(this.result.to),this.result.to));this.$cache.single.html(a);this.$cache.from.html(d);this.$cache.to.html(b);this.calcLabels();b=Math.min(this.labels.p_single_left,this.labels.p_from_left);a=this.labels.p_single_left+this.labels.p_single_fake;d=this.labels.p_to_left+this.labels.p_to_fake;var c=Math.max(a,d);this.labels.p_from_left+
        this.labels.p_from_fake>=this.labels.p_to_left?(this.$cache.from[0].style.visibility="hidden",this.$cache.to[0].style.visibility="hidden",this.$cache.single[0].style.visibility="visible",this.result.from===this.result.to?("from"===this.target?this.$cache.from[0].style.visibility="visible":"to"===this.target?this.$cache.to[0].style.visibility="visible":this.target||(this.$cache.from[0].style.visibility="visible"),this.$cache.single[0].style.visibility="hidden",c=d):(this.$cache.from[0].style.visibility=
            "hidden",this.$cache.to[0].style.visibility="hidden",this.$cache.single[0].style.visibility="visible",c=Math.max(a,d))):(this.$cache.from[0].style.visibility="visible",this.$cache.to[0].style.visibility="visible",this.$cache.single[0].style.visibility="hidden");this.$cache.min[0].style.visibility=b<this.labels.p_min+1?"hidden":"visible";this.$cache.max[0].style.visibility=c>100-this.labels.p_max-1?"hidden":"visible"}}},drawShadow:function(){var a=this.options,b=this.$cache,d="number"===typeof a.from_min&&
            !isNaN(a.from_min),c="number"===typeof a.from_max&&!isNaN(a.from_max),e="number"===typeof a.to_min&&!isNaN(a.to_min),f="number"===typeof a.to_max&&!isNaN(a.to_max);"single"===a.type?a.from_shadow&&(d||c)?(d=this.convertToPercent(d?a.from_min:a.min),c=this.convertToPercent(c?a.from_max:a.max)-d,d=this.toFixed(d-this.coords.p_handle/100*d),c=this.toFixed(c-this.coords.p_handle/100*c),d+=this.coords.p_handle/2,b.shad_single[0].style.display="block",b.shad_single[0].style.left=d+"%",b.shad_single[0].style.width=
            c+"%"):b.shad_single[0].style.display="none":(a.from_shadow&&(d||c)?(d=this.convertToPercent(d?a.from_min:a.min),c=this.convertToPercent(c?a.from_max:a.max)-d,d=this.toFixed(d-this.coords.p_handle/100*d),c=this.toFixed(c-this.coords.p_handle/100*c),d+=this.coords.p_handle/2,b.shad_from[0].style.display="block",b.shad_from[0].style.left=d+"%",b.shad_from[0].style.width=c+"%"):b.shad_from[0].style.display="none",a.to_shadow&&(e||f)?(e=this.convertToPercent(e?a.to_min:a.min),a=this.convertToPercent(f?
                a.to_max:a.max)-e,e=this.toFixed(e-this.coords.p_handle/100*e),a=this.toFixed(a-this.coords.p_handle/100*a),e+=this.coords.p_handle/2,b.shad_to[0].style.display="block",b.shad_to[0].style.left=e+"%",b.shad_to[0].style.width=a+"%"):b.shad_to[0].style.display="none")},callOnStart:function(){if(this.options.onStart&&"function"===typeof this.options.onStart)this.options.onStart(this.result)},callOnChange:function(){if(this.options.onChange&&"function"===typeof this.options.onChange)this.options.onChange(this.result)},
        callOnFinish:function(){if(this.options.onFinish&&"function"===typeof this.options.onFinish)this.options.onFinish(this.result)},callOnUpdate:function(){if(this.options.onUpdate&&"function"===typeof this.options.onUpdate)this.options.onUpdate(this.result)},toggleInput:function(){this.$cache.input.toggleClass("irs-hidden-input")},convertToPercent:function(a,b){var d=this.options.max-this.options.min;return d?this.toFixed((b?a:a-this.options.min)/(d/100)):(this.no_diapason=!0,0)},convertToValue:function(a){var b=
            this.options.min,d=this.options.max,c=b.toString().split(".")[1],e=d.toString().split(".")[1],f,l,g=0,k=0;if(0===a)return this.options.min;if(100===a)return this.options.max;c&&(g=f=c.length);e&&(g=l=e.length);f&&l&&(g=f>=l?f:l);0>b&&(k=Math.abs(b),b=+(b+k).toFixed(g),d=+(d+k).toFixed(g));a=(d-b)/100*a+b;(b=this.options.step.toString().split(".")[1])?a=+a.toFixed(b.length):(a/=this.options.step,a*=this.options.step,a=+a.toFixed(0));k&&(a-=k);k=b?+a.toFixed(b.length):this.toFixed(a);k<this.options.min?
            k=this.options.min:k>this.options.max&&(k=this.options.max);return k},calcWithStep:function(a){var b=Math.round(a/this.coords.p_step)*this.coords.p_step;100<b&&(b=100);100===a&&(b=100);return this.toFixed(b)},checkMinInterval:function(a,b,d){var c=this.options;if(!c.min_interval)return a;a=this.convertToValue(a);b=this.convertToValue(b);"from"===d?b-a<c.min_interval&&(a=b-c.min_interval):a-b<c.min_interval&&(a=b+c.min_interval);return this.convertToPercent(a)},checkMaxInterval:function(a,b,d){var c=
            this.options;if(!c.max_interval)return a;a=this.convertToValue(a);b=this.convertToValue(b);"from"===d?b-a>c.max_interval&&(a=b-c.max_interval):a-b>c.max_interval&&(a=b+c.max_interval);return this.convertToPercent(a)},checkDiapason:function(a,b,d){a=this.convertToValue(a);var c=this.options;"number"!==typeof b&&(b=c.min);"number"!==typeof d&&(d=c.max);a<b&&(a=b);a>d&&(a=d);return this.convertToPercent(a)},toFixed:function(a){a=a.toFixed(9);return+a},_prettify:function(a){return this.options.prettify_enabled?
            this.options.prettify&&"function"===typeof this.options.prettify?this.options.prettify(a):this.prettify(a):a},prettify:function(a){return a.toString().replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g,"$1"+this.options.prettify_separator)},checkEdges:function(a,b){if(!this.options.force_edges)return this.toFixed(a);0>a?a=0:a>100-b&&(a=100-b);return this.toFixed(a)},validate:function(){var a=this.options,b=this.result,d=a.values,c=d.length,e,f;"string"===typeof a.min&&(a.min=+a.min);"string"===typeof a.max&&
        (a.max=+a.max);"string"===typeof a.from&&(a.from=+a.from);"string"===typeof a.to&&(a.to=+a.to);"string"===typeof a.step&&(a.step=+a.step);"string"===typeof a.from_min&&(a.from_min=+a.from_min);"string"===typeof a.from_max&&(a.from_max=+a.from_max);"string"===typeof a.to_min&&(a.to_min=+a.to_min);"string"===typeof a.to_max&&(a.to_max=+a.to_max);"string"===typeof a.keyboard_step&&(a.keyboard_step=+a.keyboard_step);"string"===typeof a.grid_num&&(a.grid_num=+a.grid_num);a.max<a.min&&(a.max=a.min);if(c)for(a.p_values=
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       [],a.min=0,a.max=c-1,a.step=1,a.grid_num=a.max,a.grid_snap=!0,f=0;f<c;f++)e=+d[f],isNaN(e)?e=d[f]:(d[f]=e,e=this._prettify(e)),a.p_values.push(e);if("number"!==typeof a.from||isNaN(a.from))a.from=a.min;if("number"!==typeof a.to||isNaN(a.from))a.to=a.max;if("single"===a.type)a.from<a.min&&(a.from=a.min),a.from>a.max&&(a.from=a.max);else{if(a.from<a.min||a.from>a.max)a.from=a.min;if(a.to>a.max||a.to<a.min)a.to=a.max;a.from>a.to&&(a.from=a.to)}if("number"!==typeof a.step||isNaN(a.step)||!a.step||0>a.step)a.step=
            1;if("number"!==typeof a.keyboard_step||isNaN(a.keyboard_step)||!a.keyboard_step||0>a.keyboard_step)a.keyboard_step=5;"number"===typeof a.from_min&&a.from<a.from_min&&(a.from=a.from_min);"number"===typeof a.from_max&&a.from>a.from_max&&(a.from=a.from_max);"number"===typeof a.to_min&&a.to<a.to_min&&(a.to=a.to_min);"number"===typeof a.to_max&&a.from>a.to_max&&(a.to=a.to_max);if(b){b.min!==a.min&&(b.min=a.min);b.max!==a.max&&(b.max=a.max);if(b.from<b.min||b.from>b.max)b.from=a.from;if(b.to<b.min||b.to>
            b.max)b.to=a.to}if("number"!==typeof a.min_interval||isNaN(a.min_interval)||!a.min_interval||0>a.min_interval)a.min_interval=0;if("number"!==typeof a.max_interval||isNaN(a.max_interval)||!a.max_interval||0>a.max_interval)a.max_interval=0;a.min_interval&&a.min_interval>a.max-a.min&&(a.min_interval=a.max-a.min);a.max_interval&&a.max_interval>a.max-a.min&&(a.max_interval=a.max-a.min)},decorate:function(a,b){var d="",c=this.options;c.prefix&&(d+=c.prefix);d+=a;c.max_postfix&&(c.values.length&&a===c.p_values[c.max]?
            (d+=c.max_postfix,c.postfix&&(d+=" ")):b===c.max&&(d+=c.max_postfix,c.postfix&&(d+=" ")));c.postfix&&(d+=c.postfix);return d},updateFrom:function(){this.result.from=this.options.from;this.result.from_percent=this.convertToPercent(this.result.from);this.options.values&&(this.result.from_value=this.options.values[this.result.from])},updateTo:function(){this.result.to=this.options.to;this.result.to_percent=this.convertToPercent(this.result.to);this.options.values&&(this.result.to_value=this.options.values[this.result.to])},
        updateResult:function(){this.result.min=this.options.min;this.result.max=this.options.max;this.updateFrom();this.updateTo()},appendGrid:function(){if(this.options.grid){var a=this.options,b,d;b=a.max-a.min;var c=a.grid_num,e=0,f=0,g=4,h,k,m=0,n="";this.calcGridMargin();a.grid_snap?(c=b/a.step,e=this.toFixed(a.step/(b/100))):e=this.toFixed(100/c);4<c&&(g=3);7<c&&(g=2);14<c&&(g=1);28<c&&(g=0);for(b=0;b<c+1;b++){h=g;f=this.toFixed(e*b);100<f&&(f=100,h-=2,0>h&&(h=0));this.coords.big[b]=f;k=(f-e*(b-1))/
            (h+1);for(d=1;d<=h&&0!==f;d++)m=this.toFixed(f-k*d),n+='<span class="irs-grid-pol small" style="left: '+m+'%"></span>';n+='<span class="irs-grid-pol" style="left: '+f+'%"></span>';m=this.convertToValue(f);m=a.values.length?a.p_values[m]:this._prettify(m);n+='<span class="irs-grid-text js-grid-text-'+b+'" style="left: '+f+'%">'+m+"</span>"}this.coords.big_num=Math.ceil(c+1);this.$cache.cont.addClass("irs-with-grid");this.$cache.grid.html(n);this.cacheGridLabels()}},cacheGridLabels:function(){var a,
            b,d=this.coords.big_num;for(b=0;b<d;b++)a=this.$cache.grid.find(".js-grid-text-"+b),this.$cache.grid_labels.push(a);this.calcGridLabels()},calcGridLabels:function(){var a,b;b=[];var d=[],c=this.coords.big_num;for(a=0;a<c;a++)this.coords.big_w[a]=this.$cache.grid_labels[a].outerWidth(!1),this.coords.big_p[a]=this.toFixed(this.coords.big_w[a]/this.coords.w_rs*100),this.coords.big_x[a]=this.toFixed(this.coords.big_p[a]/2),b[a]=this.toFixed(this.coords.big[a]-this.coords.big_x[a]),d[a]=this.toFixed(b[a]+
            this.coords.big_p[a]);this.options.force_edges&&(b[0]<-this.coords.grid_gap&&(b[0]=-this.coords.grid_gap,d[0]=this.toFixed(b[0]+this.coords.big_p[0]),this.coords.big_x[0]=this.coords.grid_gap),d[c-1]>100+this.coords.grid_gap&&(d[c-1]=100+this.coords.grid_gap,b[c-1]=this.toFixed(d[c-1]-this.coords.big_p[c-1]),this.coords.big_x[c-1]=this.toFixed(this.coords.big_p[c-1]-this.coords.grid_gap)));this.calcGridCollision(2,b,d);this.calcGridCollision(4,b,d);for(a=0;a<c;a++)b=this.$cache.grid_labels[a][0],
            b.style.marginLeft=-this.coords.big_x[a]+"%"},calcGridCollision:function(a,b,d){var c,e,f,g=this.coords.big_num;for(c=0;c<g;c+=a){e=c+a/2;if(e>=g)break;f=this.$cache.grid_labels[e][0];f.style.visibility=d[c]<=b[e]?"visible":"hidden"}},calcGridMargin:function(){this.options.grid_margin&&(this.coords.w_rs=this.$cache.rs.outerWidth(!1),this.coords.w_rs&&(this.coords.w_handle="single"===this.options.type?this.$cache.s_single.outerWidth(!1):this.$cache.s_from.outerWidth(!1),this.coords.p_handle=this.toFixed(this.coords.w_handle/
            this.coords.w_rs*100),this.coords.grid_gap=this.toFixed(this.coords.p_handle/2-.1),this.$cache.grid[0].style.width=this.toFixed(100-this.coords.p_handle)+"%",this.$cache.grid[0].style.left=this.coords.grid_gap+"%"))},update:function(a){this.input&&(this.is_update=!0,this.options.from=this.result.from,this.options.to=this.result.to,this.options=g.extend(this.options,a),this.validate(),this.updateResult(a),this.toggleInput(),this.remove(),this.init(!0))},reset:function(){this.input&&(this.updateResult(),
            this.update())},destroy:function(){this.input&&(this.toggleInput(),this.$cache.input.prop("readonly",!1),g.data(this.input,"ionRangeSlider",null),this.remove(),this.options=this.input=null)}};g.fn.ionRangeSlider=function(a){return this.each(function(){g.data(this,"ionRangeSlider")||g.data(this,"ionRangeSlider",new r(this,a,u++))})};(function(){for(var a=0,b=["ms","moz","webkit","o"],d=0;d<b.length&&!h.requestAnimationFrame;++d)h.requestAnimationFrame=h[b[d]+"RequestAnimationFrame"],h.cancelAnimationFrame=
        h[b[d]+"CancelAnimationFrame"]||h[b[d]+"CancelRequestAnimationFrame"];h.requestAnimationFrame||(h.requestAnimationFrame=function(b,d){var f=(new Date).getTime(),g=Math.max(0,16-(f-a)),p=h.setTimeout(function(){b(f+g)},g);a=f+g;return p});h.cancelAnimationFrame||(h.cancelAnimationFrame=function(a){clearTimeout(a)})})()});